import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
// Lazy imports
const HomePage = React.lazy(() => import('./pages/homepage/content/HomePage'));
const NoMatch = React.lazy(() => import('./pages/no-match/NoMatch'));
const Programme = React.lazy(() => import('./pages/programme/agenda/programme/Programme'));
const HotelsAndTravel = React.lazy(() => import('./pages/hotels-travel/HotelsAndTravel/HotelsAndTravel'));
const Sponsorship = React.lazy(() => import('./pages/sponsorship/event-sponsorships/Sponsorship'));
const HowToParticipate = React.lazy(() => import('./pages/participate/HowToParticipate/HowToParticipate'));
const Registration = React.lazy(() => import('./pages/registration/registration/Registration'));
const Multimedia = React.lazy(() => import('./pages/multimedia/Multimedia/Multimedia'));
 

 
function App() { 
 
  const slugs = {
    es: {
      participate: 'como-participar',
      programme: 'programa',
      hotels: 'hoteles-y-viaje',
      sponsorship: 'patrocinios',
      media: 'media',
      registration: 'registro',
      multimedia: 'media',
      streaming: 'streaming'
    },
    en: {
      participate: 'how-to-participate',
      programme: 'programme',
      hotels: 'hotels-and-travel',
      sponsorship: 'sponsorship',
      media: 'media',
      registration: 'registration',
      multimedia: 'media',
      streaming: 'streaming'
    },
    'pt-br': {
      participate: 'como-participar',
      programme: 'programa',
      hotels: 'hoteis-e-viagem',
      sponsorship: 'patrocinios',
      media: 'media',
      registration: 'inscricao',
      multimedia: 'media',
      streaming: 'streaming'
    }
  };
  
  return ( 
    <Suspense fallback={<div></div>}> 
    <Routes>   
      <Route 
        index
        element={<HomePage lang="es" />} 
      />
      {Object.entries(slugs).map(([lang, routes]) => (
        <React.Fragment key={lang}> 
        <Route 
            path={lang} 
            element={<HomePage lang={lang} />} 
          />
          <Route path={`/${lang}/${routes.hotels}/*`} element={<HotelsAndTravel lang={lang} />} />
          <Route path={`/${lang}/${routes.sponsorship}/*`} element={<Sponsorship lang={lang} />} /> 
          <Route path={`/${lang}/${routes.participate}/*`} element={<HowToParticipate lang={lang} />} /> 
          <Route path={`/${lang}/${routes.registration}/*`} element={<Registration lang={lang} />} /> 
          <Route path={`/${lang}/${routes.multimedia}/*`} element={<Multimedia lang={lang} />} />  
          <Route path={`/${lang}/${routes.streaming}`} element={<Multimedia lang={lang} />} />  
          <Route path={`/${lang}/${routes.programme}/*`} element={<Programme lang={lang} />} /> 
        </React.Fragment>
       ))}   
      <Route path="*" element={<NoMatch />} />
    </Routes> 
    </Suspense>
  );
}

export default App;